import React from "react";
import { AsyncState, isErrorAs, isLoadingAs } from "./async.state";
import { SessionsDevMode, SessionsWithRecentChatIssue } from "@me8eon/sessions_messages";

export type LoadingOrErrorProps<T> = {
    state: AsyncState<T>
    whatWeAreLoading: string,
    rootId: string,
    showChildAnyway?: boolean,
    children?: (t: T) => React.ReactNode
}


export const SimpleLoadingOrError = <Data,>({
    state,
    whatWeAreLoading,
    rootId,
    children,
    showChildAnyway = false
}: LoadingOrErrorProps<Data>) => {
    if (isLoadingAs(state)) {
        return (
            <div data-testid={`${rootId}-loading-container`}>
                <span data-testid={`${rootId}-loading-text`}>Loading {whatWeAreLoading}...</span>
            </div>
        );
    } else if (isErrorAs(state)) {

        if (state.errors.length > 0) {
            const isSessionError = state.errors[0].match("The string to be decoded is not correctly encoded.");
            if (isSessionError) {

                return (
                    <div data-testid={`${rootId}-error-container`}>
                        {SessionsWithRecentChatIssue && <div><SessionsWithRecentChatIssue isRecentChatIssue={true} /></div>}
                    </div>
                );
            }
        }
        return (
            <div data-testid={`${rootId}-error-container`}>
                <br />
                {showChildAnyway && (
                    <i>Recent chat feature is down so some feature might be impacted.</i>
                )}
                <br />
                <span data-testid={`${rootId}-error-text`}>Error loading {whatWeAreLoading} {state.errors}</span>
                <br />
                <hr />
                {/* ErrorAS carries no `data` — there is nothing to hand `children` on this
                    branch, so it is not called here (it previously forced `state.data!`,
                    which is always undefined for an error state). */}
            </div>
        );
    }
    return children ? children(state.data) : null;
};